import { ConsentPath } from "../constants/paths";
import type { ConsentedPolicy } from "@/core/types";

type VersionedConsentProps = {
  policy: ConsentedPolicy;
  version: string;
};

export function getVersionedConsentHref({ policy, version }: VersionedConsentProps): string {
  const versionSegment = version ? `?version=${version}` : "";

  return `${ConsentPath[policy]}${versionSegment}`;
}
